module.exports = __webpack_public_path__ + "img/DESC_SORT.c486443a.svg";